import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Follow from './pages/Follow';
import TangataWhenuaRights from './pages/TangataWhenuaRights';
import Tinorangatiratanga from './pages/Tinorangatiratanga';
import HeWhakaputanga from './pages/HeWhakaputanga';
import WhenauHousing from './pages/WhenauHousing';
import WhenauGardening from './pages/WhenauGardening';
import BusinessPlan from './pages/BusinessPlan';
import Whakapapa from './pages/Whakapapa';
import Store from './pages/Store';
import PersonProfile from './pages/PersonProfile';
import KaupapaHistory from './pages/KaupapaHistory';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/kaupapa-history" element={<KaupapaHistory />} />
            <Route path="/follow" element={<Follow />} />
            <Route path="/tangata-whenua-rights" element={<TangataWhenuaRights />} />
            <Route path="/tinorangatiratanga" element={<Tinorangatiratanga />} />
            <Route path="/he-whakaputanga" element={<HeWhakaputanga />} />
            <Route path="/whenau-housing" element={<WhenauHousing />} />
            <Route path="/whenau-gardening" element={<WhenauGardening />} />
            <Route path="/business-plan" element={<BusinessPlan />} />
            <Route path="/whakapapa" element={<Whakapapa />} />
            <Route path="/store" element={<Store />} />
            <Route path="/profile/:personId" element={<PersonProfile />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
